// src/utils/wsClient.js

class WsClient {
  constructor({ token, onMessage, onOpen, onClose}) {
    this.token = token
    this.onMessage = onMessage
    this.onOpen = onOpen
    this.onClose = onClose

    this.ws = null
    this.heartbeatTimer = null
    this.reconnectTimer = null

    // 重连配置
    this.reconnectDelay = 3000     // 初始重连间隔（3秒）
    this.maxReconnectDelay = 30000 // 最大重连间隔（30秒）
    this.connectedOnce = false     // 首次连接标记
    this.reconnectNumber = 0
  }

  // 启动连接
  connect() {
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
    const url = `wss://api-partner.iavcms.com/ws/iot?token=${this.token}`

    try {
      this.ws = new WebSocket(url)
    } catch (err) {
      console.error('❌ 创建 WebSocket 失败:', err)
      this.scheduleReconnect()
      return
    }

    // 连接成功
    this.ws.onopen = () => {
      console.log('✅ WebSocket 已连接')
      this.connectedOnce = true
      this.reconnectDelay = 3000 // 重置延迟
      this.startHeartbeat()


      if (this.onOpen) this.onOpen()
    }

    // 收到消息
    this.ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data)
        if (this.onMessage) this.onMessage(data)
      } catch (e) {
        console.error('⚠️ 解析消息出错:', e, event.data)
      }
    }

    // 错误时也重连
    this.ws.onerror = (err) => {
      console.error('⚠️ WebSocket 出错:', err)
      this.cleanUp()
      this.scheduleReconnect()
    }

    // 关闭时重连
    this.ws.onclose = (event) => {
      console.warn(`❌ WebSocket 已关闭: code=${event.code} reason=${event.reason}`)
      this.cleanUp()
      if (this.onClose) this.onClose(event)
      this.scheduleReconnect()
    }
  }

  // 清理定时器
  cleanUp() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer)
      this.reconnectTimer = null
    }
  }

  // 安排重连
  scheduleReconnect() {
    if (this.reconnectTimer) return // 避免重复触发
    this.reconnectNumber++;
    

    if(this.reconnectNumber > 3){
     localStorage.clear()
     location.reload();    // 重新加载当前页面


    }

    console.log(`⏳ ${this.reconnectDelay / 1000}s 后重连 WebSocket...`)
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null
      console.log('🔄 正在重连...')
      this.connect()
      // 增加重连延迟（指数退避）
      this.reconnectDelay = Math.min(this.reconnectDelay * 2, this.maxReconnectDelay)
    }, this.reconnectDelay)
  }

  // 定时心跳（保持连接）
  startHeartbeat() {
    this.cleanUp()
    // this.heartbeatTimer = setInterval(() => {
    //   if (this.ws && this.ws.readyState === WebSocket.OPEN) {
    //     this.ws.send(JSON.stringify({ type: 'ping', ts: Date.now() }))
    //   }
    // }, 5000)
  }

  // 发送消息
  send(data) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      const payload = typeof data === 'string' ? data : JSON.stringify(data)
      this.ws.send(payload)
    } else {
      console.warn('⚠️ WebSocket 未连接，无法发送')
    }
  }

  // 发送指令
  sendCommand(deviceId, data,format, extra = {}) {
    this.send({
      type: 'command',
      deviceId,
      data,
      format,
      ...extra
    })
  }

  // 关闭 WebSocket 连接
  close() {
    if (this.ws) {
      this.ws.close(); // 关闭 WebSocket 连接
    } else {
      console.error('❌ WebSocket 连接不存在，无法关闭');
    }
  }
}

export default WsClient
